/**
 * OrderTableHeader Component
 * Renders dynamic table headers based on visible columns
 */

import React from 'react';
import type { OrderTableColumn } from '../../types/components';

interface OrderTableHeaderProps {
  columns: OrderTableColumn[];
  showActions?: boolean;
  className?: string;
}

export const OrderTableHeader: React.FC<OrderTableHeaderProps> = React.memo(({
  columns,
  showActions = false,
  className = ''
}) => {
  return (
    <thead className={className}>
      <tr className="bg-gray-50">
        {columns.map((column, index) => {
          // For sticky columns, use explicit positioning
          let stickyStyle = {};
          if (column.sticky) {
            // First sticky column at 0, second at 120px (hardcoded for now)
            const leftPos = column.key === 'website_job_number' ? 0 : 
                           column.key === 'delivery_postcode' ? 120 : 0;
            stickyStyle = {
              position: 'sticky',
              left: leftPos,
              zIndex: 20,
              backgroundColor: 'rgb(243 244 246)',  // bg-gray-100 - slightly darker for distinction
              minWidth: column.width,
              maxWidth: column.width
            };
          }
          
          return (
            <th 
              key={column.key}
              className={`p-2 border text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${
                column.align === 'center' ? 'text-center' : 
                column.align === 'right' ? 'text-right' : ''
              }`}
              style={{ 
                width: column.width,
                ...stickyStyle
              }}
            >
              {column.label}
            </th>
          );
        })}
        {showActions && (
          <th className="p-2 border text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Actions
          </th>
        )}
      </tr>
    </thead>
  );
});

OrderTableHeader.displayName = 'OrderTableHeader';
